import {createPlaque} from '/plaque/create_plaque.js';
import {quitPlaque} from '/plaque/quit_plaque_window.js';
import {makePlaqueQuitToggle} from '/plaque/quit_plaque_toggle.js';
import {API_GATEWAY} from '/constants/API_constants.js';
import {makeNewButton} from '/buttons_functions/custom_button_functions.js';
import { createLoadingScreen } from "/loading_screen_functions/loading_screen_functions.js";
import { insertPlaqueAndAlertWindow } from "/alert/alert_functions.js";
import { createElement } from "/elements_functions/new_elements.js";
import { abbreviateNumber } from '/misc_functions/number_display_functions.js';

export function createSubscribeToFamilyButton(branchId, subscribersCount=null) {
    const subscribeToFamilyButton = createElement('button', null, ['subscribe-to-family-button']);

    const subscribeCaption = createElement('p', null, ['subscribe-to-family-button-caption']);
    subscribeCaption.innerText = 'Subscribe';
    subscribeToFamilyButton.append(subscribeCaption);

    if(subscribersCount!==null && subscribersCount>0) {
        const subscribersCountCaption = createElement('p', null, ['subscribe-to-family-button-subscribers-count']);
        subscribersCountCaption.innerText = abbreviateNumber(subscribersCount);
        subscribeToFamilyButton.append(subscribersCountCaption);
    }

    makeNewButton(subscribeToFamilyButton, 'light-black', 'white', null, 'lighten');

    subscribeToFamilyButton.addEventListener('click', ()=>subscribeToFamily(branchId, subscribersCount, subscribeToFamilyButton));

    return subscribeToFamilyButton;
}

export function createUnsubscribeFromFamilyButton(branchId, subscribersCount=null) {
    const unsubscribeFromFamilyButton = createElement('button', null, ['subscribe-to-family-button']);

    const unsubscribeCaption = createElement('p', null, ['subscribe-to-family-button-caption']);
    unsubscribeCaption.innerText = 'Subscribed';
    unsubscribeFromFamilyButton.append(unsubscribeCaption);

    if(subscribersCount!==null && subscribersCount>0) {
        const subscribersCountCaption = createElement('p', null, ['subscribe-to-family-button-subscribers-count']);
        subscribersCountCaption.innerText = abbreviateNumber(subscribersCount);
        unsubscribeFromFamilyButton.append(subscribersCountCaption);
    }

    makeNewButton(unsubscribeFromFamilyButton, 'grey', 'black', null, 'darken');

    unsubscribeFromFamilyButton.addEventListener('click', ()=>unsubscribeFromFamily(branchId, subscribersCount, unsubscribeFromFamilyButton));

    return unsubscribeFromFamilyButton;
}

async function subscribeToFamily(branchId, subscribersCount=null, subscribeToFamilyButton) {
    if(localStorage.getItem('branchof_access_token')===null || localStorage.getItem('branchof_access_token')===undefined) {
        insertPlaqueAndAlertWindow('You are not logged in! Log in to subscribe to this user.');
        return null;
    }

    const response = await fetch(API_GATEWAY+`subscription/branch/create/branchId=${branchId}`, {
        method: 'POST',
        headers: {
            'Token-Auth' : localStorage.getItem('branchof_access_token')
        }
    });

    if(response.status===200) {
        const unsubscribeFromFamilyButton = createUnsubscribeFromFamilyButton(branchId, subscribersCount+1);
        subscribeToFamilyButton.insertAdjacentElement('beforebegin', unsubscribeFromFamilyButton);
        subscribeToFamilyButton.remove();
    } else if(response.status===204) {
        insertPlaqueAndAlertWindow("The user doesn't exist");
    } else if(response.status===403) {
        insertPlaqueAndAlertWindow("Can't subscribe to yourself. Quit trying to suck your own cock!")
    } else {
        insertPlaqueAndAlertWindow("Something went wrong while subscribing.");
    }
}

async function unsubscribeFromFamily(branchId, subscribersCount=null, unsubscribeFromFamilyButton) {
    if(localStorage.getItem('branchof_access_token')===null || localStorage.getItem('branchof_access_token')===undefined) {
        insertPlaqueAndAlertWindow('You are not logged in! Log in to unsubscribe to this user.');
        return null;
    }

    const response = await fetch(API_GATEWAY+`subscription/branch/delete/branchId=${branchId}`, {
        method: 'DELETE',
        headers: {
            'Token-Auth' : localStorage.getItem('branchof_access_token')
        }
    });

    if(response.status===200) {
        const subscribeToFamilyButton = createSubscribeToFamilyButton(branchId, subscribersCount-1);
        unsubscribeFromFamilyButton.insertAdjacentElement('beforebegin', subscribeToFamilyButton);
        unsubscribeFromFamilyButton.remove();
    } else if(response.status===204) {
        insertPlaqueAndAlertWindow("The user doesn't exist");
    } else if(response.status===401) {
        insertPlaqueAndAlertWindow("Your login has expired");
    } else {
        insertPlaqueAndAlertWindow("Something went wrong while subscribing.");
    }
}